export default "__VITE_ASSET__1uQh9SFS__"